import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// White-label guard: continuously remove any third-party platform badge
// that may be injected at runtime by the hosting environment.
const stripPlatformBadges = () => {
  const selectors = [
    '#emergent-badge',
    '[id*="emergent-badge"]',
    '[data-emergent-badge]',
    'a[href*="emergent.sh"]',
    'a[href*="app.emergent.sh"]',
  ];
  selectors.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => el.remove());
  });
};
stripPlatformBadges();
if (typeof MutationObserver !== "undefined") {
  new MutationObserver(stripPlatformBadges).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
